// Flat-top hexes in offset columns, twin of MapGrid in app/models/map_grid.rb.
const SQRT3 = Math.sqrt(3);

export function centerOf(grid, col, row) {
	return {
		x: grid.offset_x + grid.cell_w / 2 + col * 0.75 * grid.cell_w,
		y: grid.offset_y + grid.cell_h / 2 + (row + columnShift(grid, col)) * grid.cell_h,
	};
}

export function cellAt(grid, x, y) {
	const px = (x - grid.offset_x - grid.cell_w / 2) / (grid.cell_w / 2);
	const py = (y - grid.offset_y - grid.cell_h / 2) / (grid.cell_h / SQRT3);
	const { q, r } = cubeRound((px * 2) / 3, -px / 3 + py / SQRT3);
	return { col: q, row: r + parityOffset(grid, q) / 2 };
}

export function cellPolygon(grid, col, row) {
	const { x, y } = centerOf(grid, col, row);
	const halfW = grid.cell_w / 2;
	const quarterW = grid.cell_w / 4;
	const halfH = grid.cell_h / 2;
	return [x - halfW, y, x - quarterW, y - halfH, x + quarterW, y - halfH, x + halfW, y, x + quarterW, y + halfH, x - quarterW, y + halfH];
}

export function visibleCells(grid, rect) {
	const step = 0.75 * grid.cell_w;
	const firstCol = Math.floor((rect.x - grid.offset_x - grid.cell_w) / step);
	const lastCol = Math.ceil((rect.x + rect.width - grid.offset_x) / step);
	const firstRow = Math.floor((rect.y - grid.offset_y) / grid.cell_h) - 1;
	const lastRow = Math.ceil((rect.y + rect.height - grid.offset_y) / grid.cell_h);
	const cells = [];
	for (let col = firstCol; col <= lastCol; col++) {
		for (let row = firstRow; row <= lastRow; row++) cells.push({ col, row });
	}
	return cells;
}

export function distance(grid, from, to) {
	const a = toAxial(grid, from);
	const b = toAxial(grid, to);
	const dq = b.q - a.q;
	const dr = b.r - a.r;
	return (Math.abs(dq) + Math.abs(dr) + Math.abs(dq + dr)) / 2;
}

function toAxial(grid, { col, row }) {
	return { q: col, r: row - parityOffset(grid, col) / 2 };
}

function columnShift(grid, col) {
	if (col % 2 === 0) return 0;
	return grid.hex_parity === "even" ? -0.5 : 0.5;
}

function parityOffset(grid, q) {
	return grid.hex_parity === "even" ? q + (q & 1) : q - (q & 1);
}

// Ruby's Float#round (half away from zero), so both sides agree on a boundary.
function round(value) {
	return Math.sign(value) * Math.round(Math.abs(value));
}

function cubeRound(q, r) {
	const s = -q - r;
	let rq = round(q);
	let rr = round(r);
	const rs = round(s);
	const dq = Math.abs(rq - q);
	const dr = Math.abs(rr - r);
	const ds = Math.abs(rs - s);
	if (dq > dr && dq > ds) rq = -rr - rs;
	else if (dr > ds) rr = -rq - rs;
	return { q: rq + 0, r: rr + 0 };
}
